import { useEffect } from "react";

import useSegmentTrackEvent from "../../utils/useSegmentTrackEvent";

/**
 * This component sets up a global callback that allows mixpanel.track() calls
 * to use the useSegmentTrackEvent hook even outside React components.
 *
 * It should be mounted high in the component tree, after Auth and Customer contexts are available.
 */
export function SegmentTrackEventComponent() {
  const { trackEvent } = useSegmentTrackEvent({ allowNullUser: true });

  useEffect(() => {
    globalThis.segmentTrackEventCallback = trackEvent;

    return () => {
      globalThis.segmentTrackEventCallback = undefined;
    };
  }, [trackEvent]);

  return null;
}

export default SegmentTrackEventComponent;
